/**
 * A discreet "Estimated" pill for cost figures that are estimates (list-price
 * derived) rather than the customer's billed cost. Used both at the section
 * heading level and — in its `compact` "Est." form — immediately left of each
 * estimated cost figure, so estimated dollars are always indicated without being
 * prominent. The billed truth lives on the domain/org headline and Billing page.
 */
export function EstimatedTag({
  className = '',
  title,
  compact = false,
}: {
  className?: string;
  title?: string;
  /** Render the tight "Est." form for placing next to an inline cost figure. */
  compact?: boolean;
}) {
  return (
    <span
      className={`inline-flex align-middle rounded-full border border-hairline px-1.5 py-0.5 text-[0.6rem] font-semibold uppercase tracking-wide text-muted ${className}`}
      title={
        title ??
        'Estimated from discovery (list prices), not a billed figure. Billed cost is shown at the domain and org level.'
      }
    >
      {compact ? 'Est.' : 'Estimated'}
    </span>
  );
}
